import { Link } from "react-router-dom";
import MethodologyDisclaimer from "../components/MethodologyDisclaimer";
import Footer from "../components/Footer";
import BrandMark from "../components/BrandMark";
import { ArrowRight } from "lucide-react";

const setQuestionnaireType = (type) => {
  sessionStorage.setItem("srd_questionnaire_type", type);
};

export default function Landing() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Top bar */}
      <header className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto flex items-center justify-between gap-4 px-4 sm:px-6 md:px-8 py-4 md:py-5">
          <BrandMark />
          <div className="flex items-center gap-3 sm:gap-6">
            <Link to="/research" className="hop-link text-sm" data-testid="nav-research-link">
              Исследование
            </Link>
            <span className="label-mono hidden sm:inline">RU</span>
            <Link to="/admin/login" className="hop-link text-sm hidden md:inline" data-testid="admin-login-link">
              Вход для аналитиков
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1">
        {/* Hero */}
        <section className="max-w-screen-xl mx-auto px-6 sm:px-8 py-16 sm:py-24 md:py-32 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-2">
            <div className="label-mono">DIAG / 26</div>
          </div>
          <div className="md:col-span-9">
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-medium leading-[1.1] md:leading-[1.05] tracking-tight break-words">
              Диагностика готовности стартапа<br className="hidden md:inline" />
              {" "}к&nbsp;трём типам интереса
            </h1>
            <p className="mt-6 md:mt-8 text-base sm:text-lg md:text-xl text-foreground/70 max-w-3xl leading-relaxed">
              Онлайн-опросник рассчитывает три независимых индекса — инвесторский,
              корпоративный и институциональный. Результат показывает, насколько параметры проекта
              похожи на признаки, которые в исследовательской базе чаще связаны с сигналами интереса.
            </p>
            <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-4" data-testid="cta-block">
              <Link
                to="/consent"
                className="btn-primary"
                data-testid="start-mvp-btn"
                onClick={() => setQuestionnaireType("mvp")}
              >
                Короткая · 26 вопросов <ArrowRight size={16} />
              </Link>
              <Link
                to="/consent"
                className="btn-secondary"
                data-testid="start-extended-btn"
                onClick={() => setQuestionnaireType("extended")}
              >
                Расширенная · 50 вопросов <ArrowRight size={16} />
              </Link>
              <span className="label-mono">~ 10 / 25 мин</span>
            </div>
            <p className="mt-4 text-xs text-foreground/55 leading-relaxed max-w-2xl">
              Расширенная версия даёт более точный профиль за счёт дополнительных
              вопросов про команду, экономику, риски, traction-артефакты, безопасность,
              экспортную и&nbsp;закупочную готовность. Индексы и&nbsp;шкала те&nbsp;же.
            </p>
          </div>
        </section>

        {/* Indices breakdown */}
        <section className="border-t border-black/10">
          <div className="max-w-screen-xl mx-auto grid md:grid-cols-3">
            {[
              { num: "01", title: "Инвесторский интерес", desc: "Стадия, выручка, команда, инвестиционный пакет, IP-барьеры." },
              { num: "02", title: "Корпоративные пилоты", desc: "B2B/B2G применимость, измеримый эффект, пилоты, готовность к интеграции." },
              { num: "03", title: "Институты развития", desc: "R&D, IP, грантовая готовность, технологическая новизна, эффект." },
            ].map((c) => (
              <div key={c.num} className="grid-cell border-r-0 last:border-r border-l-0 first:border-l-0 md:border-l py-10 md:py-16 px-6 sm:px-8 md:px-10">
                <div className="label-mono">INDEX {c.num}</div>
                <h3 className="text-2xl md:text-3xl mt-4 font-medium">{c.title}</h3>
                <p className="mt-4 text-foreground/70 leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Methodology */}
        <section className="max-w-screen-xl mx-auto px-6 sm:px-8 py-16 md:py-24 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <div className="label-mono">МЕТОДОЛОГИЯ</div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl mt-3 font-medium">Как считается результат</h2>
          </div>
          <div className="md:col-span-7 md:col-start-6 space-y-6 text-foreground/80">
            <p className="text-base sm:text-lg leading-relaxed">
              Расчёт индексов — детерминированный. Каждый ответ даёт баллы по компонентам, веса
              компонентов фиксированы в актуальной шкале. ИИ-модель используется для анализа
              открытых ответов, презентаций и&nbsp;пересчёта их&nbsp;в&nbsp;баллы.
            </p>
            <ul className="space-y-3 text-base leading-relaxed list-disc pl-5">
              <li>Три индекса считаются раздельно. Их нельзя суммировать.</li>
              <li>Открытые ответы анализируются по&nbsp;строгой схеме извлечения фактов.</li>
              <li>Все версии вопросов, шкалы и&nbsp;правил рекомендаций сохраняются в&nbsp;каждом результате.</li>
            </ul>
          </div>
        </section>

        <section className="max-w-screen-xl mx-auto px-6 sm:px-8 pb-16">
          <MethodologyDisclaimer />
        </section>
      </main>

      <Footer />
    </div>
  );
}
